import { motion } from "framer-motion";
import React, { useRef, useState } from "react";
import "./textarea.css";
import Card from "../Card/Card";
import { Copy } from 'lucide-react';

const TextArea = () => {
  const widthSnippetRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const wCopySnippet = () => {
    if (widthSnippetRef.current) {
      const range = document.createRange();
      range.selectNode(widthSnippetRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="carve-textarea-wrapper">
        <textarea className="carve-textarea" id="multilineInput" name="multilineInput" rows="10"
          placeholder="Type your text here..." />
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>
        <div className='snippet' ref={widthSnippetRef}>
          <pre>
            <code className="ColorSnippet">
              <span className="cn">&lt;div</span>
              <span className="cln"> class="</span><span className="cn">carve-textarea-wrapper</span>
              <span className="cln">"</span><span className="cn">&gt;</span>
              <br />

              &nbsp;&nbsp;<span className="cn">&lt;textarea</span>
              <span className="cln"> class="</span><span className="cn">carve-textarea</span><span className="cln">"</span>
              <span className="cln"> id="</span><span className="cn">multilineInput</span><span className="cln">"</span>
              <span className="cln"> name="</span><span className="cn">multilineInput</span><span className="cln">"</span>
              <span className="cln"> rows="</span><span className="cn">10</span><span className="cln">"</span>
              <span className="cln"> placeholder="</span><span className="cn">Type your text here...</span><span className="cln">"</span>
              <span className="cn">&gt;&lt;/textarea&gt;</span>
              <br />

              <span className="cn">&lt;/div&gt;</span>
            </code>
          </pre>

        </div>
        <button aria-label="Copy Button" onClick={wCopySnippet}>
          <Copy />
        </button>
      </div>
    </motion.div>
  );
};
const TextAreaCard = () => {
  return (
    <Card CardTitle='TextArea' CardBody={<TextArea />} />
  );
};
export default TextAreaCard;
